/* istanbul ignore file */
import React from 'react';

import { isNannyAllowed, isNannyEnabled } from '@lumapps/nanny/ducks/selectors';
import { useSelector } from '@lumapps/redux/react';
import { createSelector } from '@lumapps/redux/reselect';
import { BackOfficeStore } from '@lumapps/redux/types';

import { NannySideNavigation as NannySideNavigationUI, NannySideNavigationProps } from './NannySideNavigation';

const isAllowedSelector = createSelector(
    [isNannyEnabled, isNannyAllowed],
    (isEnabled, isAllowed) => isEnabled && isAllowed,
);

type ConnectedProps = Omit<NannySideNavigationProps, 'isAllowed'>;

const NannySideNavigation: React.FC<ConnectedProps> = (props) => {
    const isAllowed = useSelector<BackOfficeStore, boolean>(isAllowedSelector);

    return <NannySideNavigationUI {...props} isAllowed={isAllowed} />;
};

NannySideNavigation.displayName = 'SideNavigationItem';

export { NannySideNavigation };
